/**
 * Spinner — CSS-only loading indicator.
 * Thin border, smooth spin, muted color.
 */

import { cn } from '@/lib/cn';
import type { WithClassName } from '@/types/common';

export interface SpinnerProps extends WithClassName {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeMap = {
  sm: 'h-3.5 w-3.5 border-[1.5px]',
  md: 'h-5 w-5 border-2',
  lg: 'h-7 w-7 border-2',
} as const;

export function Spinner({ size = 'md', label = 'Loading', className }: SpinnerProps): JSX.Element {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-neutral-300 border-t-primary-600',
        sizeMap[size],
        className,
      )}
    />
  );
}
